<template>
  <div style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
    <div style="margin:0 auto;width:80%;padding:10px 0" >
            <span><i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i>数据库类型</span>
      <el-input :disabled="database_type_chose"
                placeholder="请输入内容"
                @change="update_data"
                v-model="data_list.database_type"
                style="margin-bottom: 5px"
                clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>服务用名</span>
      <el-input :disabled="server_name_chose"
                @change="update_data"
                placeholder="请输入内容"
                v-model="data_list.database_server_name"
                style="margin-bottom: 5px"
                clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库名称</span>
      <el-input                 @change="update_data"

                                placeholder="请输入内容"
                v-model="data_list.database_name"
                style="margin-bottom: 5px"
                clearable>
      </el-input>
      <span style="margin-top:15px"><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>ip地址</span>
      <el-input                 @change="update_data"
                                placeholder="请输入内容"
          v-model="data_list.database_ip"
          style="margin-bottom: 5px"
          clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>端口号</span>
      <el-input
          placeholder="请输入内容"                 @change="update_data"
          v-model="data_list.database_port"
          style="margin-bottom: 5px"
          clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>用户名</span>
      <el-input @change="update_data"
          placeholder="请输入内容"
          v-model="data_list.database_user"
          style="margin-bottom: 5px"
          clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>密码</span>
      <el-input @change="update_data"
          placeholder="请输入内容"
          v-model="data_list.database_passwd"
          style="margin-bottom: 5px"
          clearable>
      </el-input>


      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库真实ip</span>
      <el-input @change="update_data"
          placeholder="请输入内容"
          v-model="data_list.real_ip"
          style="margin-bottom: 5px"
          clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库真实端口号</span>
      <el-input @change="update_data"
          placeholder="请输入内容"
          v-model="data_list.real_port"
          style="margin-bottom: 5px"
          clearable>
      </el-input>
      <span>备注</span>
      <el-input @change="update_data"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="data_list.remark">
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "new_input",
  props: [
    'Data'
  ],
  data() {
    return {
      disabled_chose: false,
      database_type_chose: false,
      server_name_chose: false,
      show_input: this.$store.state.show_input,
      data_list: this.Data.data,
      index: this.Data.index,
    };
  },
  created() {
    console.log(this.Data, 'console.log(this.show_input)')
    this.index = this.Data.index
  },
  mounted() {

    console.log(this.data_list, 'this.data_list')
  },
  methods: {
    update_data(){
      this.$emit('dataBase',this.data_list,this.index)
    },
    // server_name_disabled() {
    //   this.server_name_chose = true
    // },
    // database_type_chose_disabled() {
    //   this.database_type_chose = true
    // },
    // disabled() {
    //   this.disabled_chose = true
    // },
    get_function_type(value) {
      this.$emit('pushData', value)
    },
    clearData() {
      this.data_list = {}
    }
  }
}
</script>

<style scoped>

</style>